/** AI提示ラベル */
export const AI_SUGGESTED_LABEL = {
  /** 非全壊 */
  NOT_COLLAPSED: '00',
  /** 全壊 */
  COLLAPSED: '10'
}

/** ユーザ判定ラベル */
export const USER_LABEL = {
  /** 非全壊 */
  NOT_COLLAPSED: '00',
  /** 全壊 */
  COLLAPSED: '10'
}

/** アルゴリズム種別 */
export const ALGORITHM_TYPE = {
  /** MULTICOPTER_OR_VTOL */
  MULTICOPTER_OR_VTOL: '10',
  /** セスナ機 */
  CESSNA: '20'
} as const

/** 住家被害認定調査結果 */
export const INSPECTION_RESULT = {
  /** 無被害 */
  NO_DAMAGE: '0',
  /** 一部損壊 */
  PARTIALLY_DAMAGED: '1',
  /** 準半壊 */
  SEMI_PARTIALLY_DESTROYED: '2',
  /** 半壊 */
  PARTIALLY_DESTROYED: '3',
  /** 中規模半壊 */
  HALF_TOTALLY_DESTROYED: '4',
  /** 大規模半壊 */
  ALMOST_TOTALLY_DESTROYED: '5',
  /** 全壊 */
  TOTALLY_DESTROYED: '6',
  /** 判定不可 */
  UNDECIDABLE: '7'
} as const
